import { decomposeColor } from '@mui/material/styles';

export function rgba2rgb(rgba: Array<number>, rgbBackground: Array<number>) {
  const [r, g, b, a] = rgba;
  const [br, bg, bb] = rgbBackground;

  const nr = Math.round(br + a * (r - br));
  const ng = Math.round(bg + a * (g - bg));
  const nb = Math.round(bb + a * (b - bb));

  return `rgb(${nr}, ${ng}, ${nb})`;
}

/**
 * Returns an rgb() color using the rgb part of the original color and an alpha value.
 * (e.g., this is useful in order to obtain a non-transparent color for a background)
 *
 * Note: Does not support rgb % values nor alpha % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} alpha - alpha like in rgba(), in this range: [0,1]
 * @returns {string} rgb() color
 */

export function shade(color: string, alpha: number): string {
  const [r, g, b] = decomposeColor(color).values;
  // use percent as the new alpha value and convert to rgb
  const rgb = rgba2rgb([r, g, b, alpha], [255, 255, 255]);
  return rgb;
}

export function stringToRGB(str: string) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '';
  for (let i = 0; i < 3; i++) {
    var value = (hash >> (i * 8)) & 0xff;
    color += ('00' + value.toString(16)).slice(-2);
  }

  return color;
}

//https://stackoverflow.com/a/54569758
export function invertHex(hex: string) {
  return (Number(`0x1${hex}`) ^ 0xffffff).toString(16).substring(1).toUpperCase();
}
